import { formatFixedNumber } from "../../../utils/utils";

export interface AutoCalculationResult {
  fieldName: string;
  calculatedValue: number | null;
  isValid: boolean;
  errorMessage?: string;
}

// biome-ignore lint/complexity/noStaticOnlyClass: used as a namespace across callers; converting changes every call site
export class AutoCalculationManager {
  /**
   * Auto-calculate ortho_amount_remaining based on ortho_lifetime_max_benefit and ortho_amount_used
   */
  static calculateOrthoAmountRemaining(
    orthoLifetimeMaxBenefit: string | null,
    orthoAmountUsed: string | null,
  ): AutoCalculationResult {
    const fieldName = "ortho_amount_remaining";

    if (
      orthoLifetimeMaxBenefit === null ||
      orthoLifetimeMaxBenefit === undefined ||
      orthoLifetimeMaxBenefit === ""
    ) {
      return {
        fieldName,
        calculatedValue: null,
        isValid: true,
      };
    }

    const maxBenefit = parseFloat(orthoLifetimeMaxBenefit);
    if (Number.isNaN(maxBenefit)) {
      return {
        fieldName,
        calculatedValue: null,
        isValid: false,
        errorMessage: "Invalid lifetime max benefit value",
      };
    }

    if (
      orthoAmountUsed === null ||
      orthoAmountUsed === undefined ||
      orthoAmountUsed === ""
    ) {
      return {
        fieldName,
        calculatedValue: formatFixedNumber(maxBenefit, 2),
        isValid: true,
      };
    }

    const amountUsed = parseFloat(orthoAmountUsed);
    if (Number.isNaN(amountUsed)) {
      return {
        fieldName,
        calculatedValue: null,
        isValid: false,
        errorMessage: "Invalid amount used value",
      };
    }

    if (amountUsed > maxBenefit) {
      return {
        fieldName,
        calculatedValue: null,
        isValid: false,
        errorMessage: `Amount used (${amountUsed}) cannot exceed lifetime max benefit (${maxBenefit})`,
      };
    }

    const remaining = maxBenefit - amountUsed;

    return {
      fieldName,
      calculatedValue: formatFixedNumber(remaining, 2),
      isValid: true,
    };
  }
}
